(function () {
  function start() {
    var wrap = document.querySelector('[data-vt-chat]');
    if (!wrap || wrap.dataset.vtChatKlaar) return;
    wrap.dataset.vtChatKlaar = '1';
    var eindpunt = 'https://voltrade-chat.vercel.app/api/chat';
    var knop = wrap.querySelector('[data-chat-open]');
    var paneel = wrap.querySelector('[data-chat-paneel]');
    var stroom = wrap.querySelector('[data-chat-stroom]');
    var starters = wrap.querySelector('[data-chat-starters]');
    var welkom = wrap.querySelector('[data-chat-welkom]');
    var form = wrap.querySelector('[data-chat-form]');
    var veld = wrap.querySelector('[data-chat-veld]');
    var stuurknop = wrap.querySelector('[data-chat-stuur]');
    var uren = wrap.querySelector('[data-chat-uren]');
    var bezig = false;
    var berichten = [];
    var gevraagd = 0;
    var mensAangeboden = false;

    var gemeld = {};
    function meld(naam, gegevens) {
      if (gemeld[naam]) return;
      gemeld[naam] = true;
      try {
        if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
          Shopify.analytics.publish(naam, gegevens);
        }
      } catch (e) {}
    }

    var VRAAGT_MENS = /\b(mens|medewerker|iemand spreken|persoon|bellen|telefoon|contact|whatsapp|klantenservice)\b/i;
    function biedMensAan() {
      if (mensAangeboden || !wrap.dataset.tMens) return;
      mensAangeboden = true;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'vt-chat__kans';
      b.setAttribute('data-chat-mens', '');
      var foto = wrap.querySelector('.vt-chat__gezicht img');
      if (foto) {
        var img = document.createElement('img');
        img.src = foto.currentSrc || foto.src;
        img.alt = '';
        b.appendChild(img);
      }
      var s = document.createElement('span');
      s.textContent = wrap.dataset.tMens;
      b.appendChild(s);
      stroom.appendChild(b);
      naarBeneden();
    }

    function alsUren(w, standaard) {
      var t = String(w || '').trim().replace(',', '.');
      if (!t) return standaard;
      var delen = t.split(':');
      var u = parseFloat(delen[0]) + (delen.length > 1 ? (parseFloat(delen[1]) || 0) / 60 : 0);
      return isNaN(u) ? standaard : u;
    }

    function klok(u) {
      var uur = Math.floor(u), min = Math.round((u - uur) * 60);
      return uur + ':' + (min < 10 ? '0' + min : min);
    }

    function bereikbaar() {
      if (window.vtTijd) return window.vtTijd.isOpen();
      var d = new Date(), dag = d.getDay();
      if (dag === 0 || dag === 6) return false;
      var u = d.getHours() + d.getMinutes() / 60;
      return u >= alsUren(wrap.dataset.openVan, 9) &&
             u < alsUren(wrap.dataset.openTot, 17.5);
    }

    function toonUren() {
      var open = bereikbaar();
      var tot = klok(alsUren(wrap.dataset.openTot, 17.5)), van = klok(alsUren(wrap.dataset.openVan, 9));
      if (uren) {
        uren.textContent = open
          ? wrap.dataset.tUrenOpen.replace('[tot]', tot)
          : wrap.dataset.tUrenDicht.replace('[van]', van);
      }
    }

    if (wrap.parentNode !== document.body) document.body.appendChild(wrap);

    function meetHoogte() {
      var vv = window.visualViewport;
      var h = vv ? vv.height : window.innerHeight;
      var top = vv ? vv.offsetTop : 0;
      wrap.style.setProperty('--vt-chat-vh', h + 'px');
      wrap.style.setProperty('--vt-chat-top', top + 'px');
    }
    function volgViewport(aan) {
      var doe = aan ? 'addEventListener' : 'removeEventListener';
      if (window.visualViewport) {
        window.visualViewport[doe]('resize', meetHoogte);
        window.visualViewport[doe]('scroll', meetHoogte);
      }
      window[doe]('resize', meetHoogte);
    }

    var breed = window.matchMedia('(min-width: 768px)');
    var mobiel = function () { return !breed.matches; };

    var vergrendeld = false;
    function vastzetten(ja) {
      var d = window.VtDialoog;
      if (!d || !d.vergrendel || ja === vergrendeld) return;
      if (ja) d.vergrendel(); else d.ontgrendel();
      vergrendeld = ja;
    }
    breed.addEventListener('change', function () {
      vastzetten(wrap.classList.contains('is-open') && mobiel());
    });

    function open(ja, bron) {
      var r = (bron && mobiel() ? bron : knop).getBoundingClientRect();
      wrap.style.setProperty('--vt-chat-x', (r.left + r.width / 2) + 'px');
      wrap.style.setProperty('--vt-chat-y', (r.top + r.height / 2) + 'px');

      wrap.classList.toggle('is-open', ja);
      knop.setAttribute('aria-expanded', ja ? 'true' : 'false');
      vastzetten(ja && mobiel());
      if (ja) setTimeout(function () {
        if (wrap.classList.contains('is-open')) wrap.classList.add('is-onthuld');
      }, 480);
      else wrap.classList.remove('is-onthuld');
      volgViewport(ja);
      if (ja) {
        meld('vt_chat_open', { bron: bron ? 'hulpblok' : 'chatknop', pagina: location.pathname });
        wrap.classList.remove('toon-tip');
        toonUren(); meetHoogte();
        setTimeout(function () { if (!mobiel()) veld.focus(); }, 260);
      } else {
        wrap.classList.remove('toon-kaart');
        knop.focus();
      }
    }

    window.vtChat = {
      vraag: function (tekst, bron) {
        if (!wrap.classList.contains('is-open')) open(true, bron);
        if (bezig) {
          veld.value = tekst;
          stuurknop.disabled = false;
        } else {
          stuur(tekst);
        }
        return true;
      }
    };

    function naarBeneden() { stroom.scrollTo({ top: stroom.scrollHeight, behavior: 'smooth' }); }

    function toon(rol, tekst) {
      var d = document.createElement('div');
      d.className = 'vt-chat__bericht vt-chat__bericht--' + rol;
      var paden = [];
      var schoon = tekst.replace(/\(?(\/(products|pages|collections)\/[a-z0-9\-\/]+)\)?/gi,
        function (_, pad) { if (paden.indexOf(pad) < 0) paden.push(pad); return ''; });
      schoon = schoon.replace(/[ \t]{2,}/g, ' ').replace(/ +([.,])/g, '$1').trim();
      d.textContent = schoon;
      if (paden.length) {
        var rij = document.createElement('span');
        rij.className = 'vt-chat__links';
        paden.forEach(function (pad) {
          var a = document.createElement('a');
          a.className = 'vt-chat__link';
          a.href = pad;
          var naam = pad.split('/').filter(Boolean).pop().replace(/-/g, ' ');
          a.textContent = naam.charAt(0).toUpperCase() + naam.slice(1);
          rij.appendChild(a);
        });
        d.appendChild(rij);
      }
      stroom.appendChild(d);
      naarBeneden();
      return d;
    }

    function stuur(tekst) {
      if (bezig || !tekst) return;
      bezig = true;
      stuurknop.disabled = true;
      if (welkom) { welkom.remove(); welkom = null; starters = null; }
      toon('mens', tekst);
      gevraagd += 1;
      meld('vt_chat_vraag', { pagina: location.pathname });
      var wilMens = VRAAGT_MENS.test(tekst);
      berichten.push({ role: 'user', content: tekst });
      veld.value = '';

      var wacht = document.createElement('div');
      wacht.className = 'vt-chat__bericht vt-chat__bericht--bot vt-chat__laadt';
      wacht.setAttribute('aria-label', wrap.dataset.tZoeken);
      wacht.innerHTML = '<span class="vt-chat__accu"><i></i></span><span class="vt-chat__laadt-tekst"></span>';
      wacht.querySelector('.vt-chat__laadt-tekst').textContent = wrap.dataset.tZoeken;
      stroom.appendChild(wacht);
      naarBeneden();

      var afbreken = window.AbortController ? new AbortController() : null;
      var wekker = setTimeout(function () { if (afbreken) afbreken.abort(); }, 25000);

      fetch(eindpunt, {
        method: 'POST',
        signal: afbreken ? afbreken.signal : undefined,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          berichten: berichten,
          pagina: location.pathname,
          zakelijk: wrap.dataset.zakelijk === '1',
        }),
      }).then(function (r) { return r.json(); }).then(function (d) {
        wacht.remove();
        if (!d.antwoord) return mislukt(tekst, d.error || wrap.dataset.tFout);
        toon('bot', d.antwoord);
        berichten.push({ role: 'assistant', content: d.antwoord });
        if (wilMens || gevraagd >= 3) biedMensAan();
      }).catch(function () {
        wacht.remove();
        mislukt(tekst, wrap.dataset.tVerbinding);
      }).finally(function () {
        clearTimeout(wekker);
        bezig = false;
        stuurknop.disabled = veld.value.trim() === '';
      });
    }

    function mislukt(tekst, melding) {
      berichten.pop();
      var b = toon('bot', melding);
      var a = document.createElement('a');
      a.className = 'vt-chat__uitweg';
      a.href = wrap.dataset.service + '?vraag=' + encodeURIComponent(tekst) + '#vt-sv-contact';
      a.textContent = wrap.dataset.tMail;
      b.appendChild(a);
      if (!veld.value.trim()) veld.value = tekst;
      biedMensAan();
    }

    var tip = wrap.querySelector('[data-chat-tip]');
    if (tip) {
      setTimeout(function () { if (!wrap.classList.contains('is-open')) wrap.classList.add('toon-tip'); }, 4000);
      setTimeout(function () { wrap.classList.remove('toon-tip'); }, 16000);
      tip.addEventListener('click', function () { open(true); });
    }

    knop.addEventListener('click', function () { open(!wrap.classList.contains('is-open')); });
    wrap.querySelectorAll('[data-chat-sluit]').forEach(function (b) {
      b.addEventListener('click', function () { open(false); });
    });
    paneel.addEventListener('click', function (e) {
      if (!e.target.closest('[data-chat-mens]')) return;
      toonUren(); wrap.classList.add('toon-kaart');
    });
    wrap.querySelector('[data-chat-terug]').addEventListener('click', function () {
      wrap.classList.remove('toon-kaart');
    });
    veld.addEventListener('input', function () { stuurknop.disabled = veld.value.trim() === '' || bezig; });
    veld.addEventListener('focus', function () {
      setTimeout(function () {
        meetHoogte();
        if (vergrendeld) window.scrollTo(0, 0);
        if (!welkom) naarBeneden();
      }, 320);
    });
    form.addEventListener('submit', function (e) { e.preventDefault(); stuur(veld.value.trim()); });
    if (starters) starters.addEventListener('click', function (e) {
      var b = e.target.closest('[data-chat-starter]');
      if (b) stuur(b.querySelector('span').textContent.trim());
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (wrap.classList.contains('toon-kaart')) wrap.classList.remove('toon-kaart');
      else if (wrap.classList.contains('is-open')) open(false);
    });
    toonUren();
    document.addEventListener('vt:tijd', toonUren);
  }

  start();
  document.addEventListener('shopify:section:load', start);
})();
